import { render } from "./footprint.vue?vue&type=template&id=6adcaa2d&scoped=true"
import script from "./footprint.vue?vue&type=script&lang=js"
export * from "./footprint.vue?vue&type=script&lang=js"

import "./footprint.vue?vue&type=style&index=0&id=6adcaa2d&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adcaa2d"]])

export default __exports__